import { getProductJson, getVariantFromOptionArray } from '@shopify/theme-product';
import fireDrawerEvent from './utilities/fireDrawerEvent';

const CART_WRAPPER_ID = 'cart-wrapper';

const $win = $(window);
const $doc = $(document);

const $html = $('html');
const $body = $('body');
const $cart = $('.section-cart .form--cart');
const $cartBody = $cart.find('.form__body');

const $cartPopup = $('.cart__wrapper');
const $cartPopupForm = $cartPopup.find('form');
const $cartPopupFormBody = $cartPopupForm.find('.form__body');

const btnQty = '.product__qty .btn-qty';
const addToCartForm = 'form[action="/cart/add"]';
const variantSelect = document.querySelector('[name="id"]');

const $pdpForm = document.querySelector(addToCartForm);

if ($('input#cart-note').length) {
  let value = $('input#cart-note').val();

  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType: 'JSON',
    data: 'attributes[Cart Note]=' + value
  });
}

// Product variant change
$('[data-product-option]').on('change', function () {
  const $this = $(this);
  const $submitButton = $this.closest('form').find('[type=submit]');
  const optionArray = [];
  const $productHandle = $pdpForm.getAttribute('data-product-handle');
  const selectedOptions = document.querySelectorAll('[name^=options]');

  if (!selectedOptions) {
    return;
  }
  
  // Build array of option values
  for (let i = 0; i < selectedOptions.length; i++) {
    optionArray.push(selectedOptions[i].value);
  }

  const variant = getVariantFromOptionArray(liquid_product_json, optionArray);
  
  if (variant) {
    selectVariant(variant.id);
    toggleCartButton($submitButton, true);
  } else {
    toggleCartButton($submitButton, false);
  }
});

$doc
  .on('submit', addToCartForm, function(e) {
    e.preventDefault();
    addToCart($(this));
  })
  .on('click', '.product__qty .btn-qty', function(e) {
    e.preventDefault();
    updateQty($(this));
  })
  .on('change', '.field--quantity', function(e) {
    const $form = $(this).closest('form');
    const $formAction = $form.attr('action');

    // Only update cart where AJAX cart is being used
    if ($formAction != '/cart/add') {
      updateCart($form);
    }
  })
  .on('change', '#field-note', function(e) {
    var $this = $(this);
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'JSON',
      data: 'note=' + $this.val()
    });
  })
  .on('click', '.remove', function(e) {
    e.preventDefault();
    let href = $(this).attr('href');

    $(this)
      .closest('.product')
      .slideUp();
    setTimeout(removeProduct(href), 300);
  });

function removeProduct($this) {
  $.post($this).done(function() {
    $.ajax({
      url: '/cart',
      success: function(response) {
        updateCartContent();
        updateTotal(response);
      }
    });
  });
}

function toggleCartButton(button, active) {
  if (active == true) {
    button.removeAttr('disabled');
  } else {
    button.attr('disabled', 'disabled');
  }
}

function updateVariantQueryParam(id) {
  const url = window.location.href;
  const baseURL = url.split('?variant=')[0];
  const variantRegex = new RegExp(/\?variant=[1-9]/, 'i');
  const hasVariantParam = variantRegex.test(url);
  const queryString = '?variant=' + id;
  window.history.pushState('', '', queryString);
}

// Update hidden select //
function selectVariant(id) {
  variantSelect.value = id;
  updateVariantQueryParam(id);
  variantSelect.dispatchEvent(new Event('change'));
}

// Update Product Quantity //
function updateQty($btn) {
  const handle = '/products/' + $btn.data('handle') + '.js';
  const $productQty = $btn.closest('.product__qty');
  const $productPrice = $btn.closest('tr').find('.table__total-price .price');
  const $productRemove = $btn.closest('tr').find('.remove');
  const $form = $btn.closest('.form');
  const $input = $productQty.find('.field--quantity');
  const $productTotalPrice = $form.find('.table__total-value .price');
  const step = parseInt($btn.data('step'));
  let val = parseInt($input.val());
  val += step;

  if (val > 0) {
    $input.val(val).change();
  } else {
    if (!$input.hasClass('product__quantity')) {
      $btn.closest('.product').slideUp();
      setTimeout(removeProduct($productRemove.attr('href')), 300);
    }
  }

  jQuery.getJSON(handle, function(product) {
    if ($productPrice) {
      $productPrice.html(Shopify.formatMoney(product.price * val));
    }
  });
}

function openCartDrawer() {
  $html.addClass('cart-expanded');
  fireDrawerEvent.open(CART_WRAPPER_ID);
}

// Add product to cart with Ajax //
function addToCart($form) {
  var serializeForm = $form.serialize();

  $.ajax({
    type: 'POST',
    url: '/cart/add',
    dataType: 'html',
    data: serializeForm,
    success: function(response) {
      updateCartContent();
      updateTotal(response);
      openCartDrawer();
    },
    error: function(data) {
      console.log(data);
    }
  });
}

function updateCart($form) {
  const serializeForm = $form.serialize();

  $.ajax({
    url: '/cart/update.js',
    data: serializeForm,
    dataType: 'json'
  }).done(function(response) {
    updateCartContent();
  });
}

function updateCartContent() {
  $.ajax({
    url: '/cart'
  }).done(function(response) {
    const $formBodyNew = $(response).find('.section-cart form .form__body');

    if ($cartBody.length == 0) {
      $cartPopupFormBody.html($formBodyNew.html());
    } else {
      $cartBody.html($formBodyNew.html());
    }
  });
}

function updateTotal(response) {
  const $totalNew = $(response).find('.section-cart .table__total-value .price');

  $('.table__total-value .price').each(function() {
    $(this).html($totalNew.html());
  });
}
